import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export type DotsGridIconProps = IconProps;

export const DotsGridIcon: FC<DotsGridIconProps> = ({
  iconColor = '#2565C8',
  className,
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6673 3.99984C11.0355 3.99984 11.334 3.70136 11.334 3.33317C11.334 2.96498 11.0355 2.6665 10.6673 2.6665C10.2991 2.6665 10.0007 2.96498 10.0007 3.33317C10.0007 3.70136 10.2991 3.99984 10.6673 3.99984Z"
      stroke={iconColor}
      stroke-width="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6673 8.6665C11.0355 8.6665 11.334 8.36803 11.334 7.99984C11.334 7.63165 11.0355 7.33317 10.6673 7.33317C10.2991 7.33317 10.0007 7.63165 10.0007 7.99984C10.0007 8.36803 10.2991 8.6665 10.6673 8.6665Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M10.6673 13.3332C11.0355 13.3332 11.334 13.0347 11.334 12.6665C11.334 12.2983 11.0355 11.9998 10.6673 11.9998C10.2991 11.9998 10.0007 12.2983 10.0007 12.6665C10.0007 13.0347 10.2991 13.3332 10.6673 13.3332Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M6.00065 3.99984C6.36884 3.99984 6.66732 3.70136 6.66732 3.33317C6.66732 2.96498 6.36884 2.6665 6.00065 2.6665C5.63246 2.6665 5.33398 2.96498 5.33398 3.33317C5.33398 3.70136 5.63246 3.99984 6.00065 3.99984Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M6.00065 8.6665C6.36884 8.6665 6.66732 8.36803 6.66732 7.99984C6.66732 7.63165 6.36884 7.33317 6.00065 7.33317C5.63246 7.33317 5.33398 7.63165 5.33398 7.99984C5.33398 8.36803 5.63246 8.6665 6.00065 8.6665Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
    <path
      d="M6.00065 13.3332C6.36884 13.3332 6.66732 13.0347 6.66732 12.6665C6.66732 12.2983 6.36884 11.9998 6.00065 11.9998C5.63246 11.9998 5.33398 12.2983 5.33398 12.6665C5.33398 13.0347 5.63246 13.3332 6.00065 13.3332Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
